import React, { useState } from "react";
import { Box } from "@mui/material";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import SpeciesCatch from "./SpeciesCatch";

const SpeciesCatchTable = ({
  catchList,
  addCatch,
  startEditing,
  stopEditing,
  onDelete,
  editIdx,
  type,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentItem, setCurrentItem] = useState({});
  const [currentlyEditing, setCurrentlyEditing] = useState(false);

  return (
    <>
      <Box display="flex" justifyContent="center">
        <SpeciesCatch
          catchList={catchList}
          addCatch={addCatch}
          type={type}
          isVisible={isVisible}
          setIsVisible={setIsVisible}
          currentItem={currentItem}
          currentlyEditing={currentlyEditing}
          setCurrentlyEditing={setCurrentlyEditing}
          stopEditing={stopEditing}
          onDelete={onDelete}
        />
      </Box>
      <Box display="flex" justifyContent="center">
        <List
          component="nav"
          sx={{
            width: "100%",
            maxWidth: "350px",
            margin: "0px",
            position: "relative",
            overflow: "auto",
            maxHeight: "650px",
          }}
          dense
        >
          {catchList.map((item, idx) => {
            return (
              <ListItem
                key={idx}
                style={{
                  justifyContent: "space-between",
                  borderRadius: "5px",
                  backgroundColor: "#eeeeee",
                }}
                onClick={() => {
                  startEditing(idx);
                  setIsVisible(true);
                  setCurrentlyEditing(true);
                  setCurrentItem({
                    ...item,
                    idx,
                  });
                }}
                divider
              >
                <ListItemText>
                  {`Species: ${item.name}`}
                  <br />
                  {`Kept: ${item.kept}`}
                  {type === "efp" && (
                    <>
                      <br />
                      {`Discarded: ${item.discarded}`}
                    </>
                  )}
                  <br />
                  UOM: LB
                </ListItemText>
                <ListItemIcon style={{ minWidth: "0px" }}>
                  <NavigateNextIcon />
                </ListItemIcon>
              </ListItem>
            );
          })}
        </List>
      </Box>
    </>
  );
};

export default SpeciesCatchTable;
